import { IStimUnitRate } from '../../interfaces/istim-unit-rate';
import { UnitOfMeasure } from '../unit-of-measure';

export class StimUnitRateBase {
  StimUnitRateId: number;
  Description: string;
  UnitRate: number;
  UnitOfMeasureId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  UnitOfMeasure?: UnitOfMeasure;

  constructor(item?: IStimUnitRate) {
    if (item) {

      this.StimUnitRateId = item.StimUnitRateId;
      this.Description = item.Description;
      this.UnitRate = item.UnitRate;
      this.UnitOfMeasureId = item.UnitOfMeasureId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.UnitOfMeasure = new UnitOfMeasure(item.UnitOfMeasure);
    }
  }
}